import { Session } from '@chromia/ft4';

import { iChrBalance, iExpiredOption, iParams, iTypedGtxClient } from '../../interfaces/chrInterfaces';

export enum eChromiaActionTypes {
	CLEAR_STATE = 'CHR/CLEAR_STATE',
	// SET_ACCOUNT_DETAILS = 'CHR/SET_ACCOUNT_DETAILS',
	SET_CHR_USER_ADDRESS = 'CHR/SET_CHR_USER_ADDRESS',
	SET_GTX_CLIENT = 'CHR/SET_GTX_CLIENT',
	SET_SESSION = 'CHR/SET_SESSION',
	SET_PARAMS = 'CHR.SET_PARAMS',
	SET_TOKEN_BALANCES = 'CHR/SET_TOKEN_BALANCES',
	SET_EXPIRED_OPTIONS = 'CHR/SET_EXPIRED_OPTIONS',
	SET_IS_INITING = 'CHR/SET_IS_INITING'
}

export type tChromiaAction =
	iClearStateAction |
	// set_account_details_action |
	iSetChrUserAddressAction |
	iSetGtxClientAction |
	iSetSessionAction |
	iSetParamsAction |
	iSetTokenBalancesAction |
	iSetExpiredOptionsAction |
	iSetIsInitingAction
;

interface iClearStateAction {
	type: eChromiaActionTypes.CLEAR_STATE
}

/* interface set_account_details_action {
	type: chromia_action_types.SET_ACCOUNT_DETAILS,
	payload: iFullfilled_account_details
} */

interface iSetChrUserAddressAction {
	type: eChromiaActionTypes.SET_CHR_USER_ADDRESS,
	payload: string | null
}

interface iSetTokenBalancesAction {
	type: eChromiaActionTypes.SET_TOKEN_BALANCES,
	payload: iChrBalance[]
}

interface iSetExpiredOptionsAction {
	type: eChromiaActionTypes.SET_EXPIRED_OPTIONS,
	payload: iExpiredOption[]
}

interface iSetGtxClientAction {
	type: eChromiaActionTypes.SET_GTX_CLIENT,
	payload: iTypedGtxClient
}

interface iSetSessionAction {
	type: eChromiaActionTypes.SET_SESSION,
	payload: Session | null
}

interface iSetParamsAction {
	type: eChromiaActionTypes.SET_PARAMS,
	payload: iParams
}

interface iSetIsInitingAction {
	type: eChromiaActionTypes.SET_IS_INITING,
	payload: boolean
}